import {
  CreateContextProvider,
  Form,
  useCreateController,
  useNotify,
  useRefresh,
  useTranslate,
} from 'react-admin';
import { Button as MUIButton, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Resources } from '../../resource';
import InterventionForm from './InterventionForm';
import { grantRedPacket } from '../../../services/redpacketService';
import { useFormContext } from 'react-hook-form';
import { PermissionButton } from '../../../../../routes/components/permission-button';

const CreateIntervention = ({ onClose }: { onClose: () => void }) => {
  const notify = useNotify();
  const t = useTranslate();
  const refresh = useRefresh();

  const controller = useCreateController({
    resource: Resources.redpacket,
    mutationOptions: {
      onSuccess: () => {
        notify('created successfully', { type: 'success' });
        refresh();
        onClose();
      },
      onError: (error: any) => {
        notify(error.message || 'creation failed', { type: 'error' });
      },
    },
  });

  const CustomSaveButton = () => {
    const { handleSubmit } = useFormContext();
    const onSubmit = async (data: any) => {
      try {
        await grantRedPacket({
          walletAddress: data.userId,
          amount: String(data.amount),
          type: data.type,
          reason: data.reason,
        });
        notify('created successfully', { type: 'success' });
        refresh();
        onClose();
      } catch (error: any) {
        notify(error.message || 'creation failed', { type: 'error' });
      }
    };
    return <MUIButton onClick={handleSubmit(onSubmit)}>Save</MUIButton>;
  };

  return (
    <CreateContextProvider value={controller}>
      <Form disableInvalidFormNotification>
        <DialogTitle>Create Intervention Red Packet</DialogTitle>
        <DialogContent>
          <InterventionForm isCreate />
        </DialogContent>
        <DialogActions>
          <MUIButton variant="outlined" onClick={onClose}>
            {t('actions.cancel')}
          </MUIButton>
          <PermissionButton resource="redpacket" action="create">
            <CustomSaveButton />
          </PermissionButton>
        </DialogActions>
      </Form>
    </CreateContextProvider>
  );
};

export default CreateIntervention;
